/**
 * 16進数シーケンスをEmoji文字に変換
 * ハイフン有無両方に対応
 * ハイフンなし: "1F600" → ["1F600"] → [128512] → 😀
 * ハイフン有り: "0031-fe0f-20e3" → ["0031", "fe0f", "20e3"] → [49, 65039, 8419] → 1️⃣
 */
export const parseIconToChar = (val: string | undefined | null): string => {
  if (val === undefined || val === null || val === '') return ''
  try {
    const parts = val.split('-').map((p) => parseInt(p, 16))
    if (parts.length > 0 && parts.every((n) => !Number.isNaN(n))) {
      return String.fromCodePoint(...parts)
    }
  } catch (e) {
    console.error('[parseIconToChar] error:', e, 'val:', val)
  }
  return val
}
